// @flow

import type {
  EcommerceEvent,
  EventAction,
  EventActionCreator,
  EventHandler,
  GtmEcommerceItem,
} from 'redux/middleware/googleTagManager/types';

import {EVENT_ECOMMERCE} from 'redux/middleware/googleTagManager/actionTypes';

type Payload = {
  event: string,
  event_action: string,
  login_status?: string,
  non_interaction: boolean,
  checkout_step?: string,
  event_category?: string,
  items: GtmEcommerceItem[],
  additionalEcommerceParams?: {
    transaction_id: string,
    value: number,
    currency: 'EUR',
  },
};

type Action = EventAction<Payload>;

export const action: EventActionCreator<Action, Payload> = (
  payload: Payload
) => ({
  type: EVENT_ECOMMERCE,
  payload,
});

export const handler: EventHandler<Action, EcommerceEvent> = (action) => ({
  event: action.payload.event,
  event_action: action.payload.event_action,
  non_interaction: action.payload.non_interaction,
  ...(action.payload.user_data ? {user_data: action.payload.user_data} : {}),
  ...(action.payload.login_status
    ? {login_status: action.payload.login_status}
    : {}),
  ...(action.payload.checkout_step
    ? {checkout_step: action.payload.checkout_step}
    : {}),
  ecommerce: {
    ...action.payload?.additionalEcommerceParams,
    items: action.payload.items,
  },
  ...(action.payload.touroperator_voucher
    ? {touroperator_voucher: action.payload.touroperator_voucher}
    : {}),
  ...(action.payload.coupon_value
    ? {coupon_value: action.payload.coupon_value}
    : {}),
  ...(action.payload.event_category
    ? {event_category: action.payload.event_category}
    : {}),
});

export const clearer: {} = () => ({ecommerce: null});
